export default __webpack_public_path__ + "static/media/poolandfarm.c90fdc71.png";